import { Metrics, MetricsEntries } from "~/lib/arrow";
import { useDailyCounts } from "./useDailyCounts";

export interface UseDailyAssetCountsParams {
  entityMrn: string;
  numOfDays?: number;
  entries?: MetricsEntries;
}

export function useDailyAssetCounts({
  entityMrn,
  numOfDays = 28,
  entries,
}: UseDailyAssetCountsParams) {
  return useDailyCounts({
    entityMrn,
    numOfDays,
    metricMrn: Metrics.HistoricalDailyAssetCount,
    entries,
  });
}
